var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-Print';
                    var viewUrl = 'gfx/sprite.svg#view-icon-Print';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 23 22',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };